export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.7d6e6224.worker.js");
}
